import { render } from "./Bienvenida.vue?vue&type=template&id=07670801&scoped=true"
import script from "./Bienvenida.vue?vue&type=script&lang=js"
export * from "./Bienvenida.vue?vue&type=script&lang=js"

import "./Bienvenida.vue?vue&type=style&index=0&id=07670801&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07670801"]])

export default __exports__